import { Button, UIText2 } from '@cian/ui-kit';
import { IconToggleHeartOff16, IconToggleHeartOn16 } from '@cian/ui-kit-design-tokens/icons';

import { LikeButton } from '../like';

import * as styles from './index.css';

/**
 * Адаптивная кнопка избранного, которая схлопывается в иконку на разрешении width < 1240px
 */
export class AdaptiveLikeButton extends LikeButton {
  public render() {
    const { isActive } = this.state;

    return (
      <Button
        beforeIcon={
          <span className={styles['like-button']}>
            {isActive ? (
              <IconToggleHeartOn16 color="icon-negative-default" />
            ) : (
              <IconToggleHeartOff16 color="icon-secondary-default" />
            )}
            <span className={styles['button-text']}>
              <UIText2 color="text-primary-default" fontWeight="700">
                {isActive ? 'В избранном' : 'В избранное'}
              </UIText2>
            </span>
          </span>
        }
        size="XS"
        theme="stroke_secondary"
        onClick={this.handleClick}
      />
    );
  }
}
